export default __webpack_public_path__ + "static/background-c4a84abac28b54ba81ed34572c22f361.jpg";